import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-dashboard-tab5',
  templateUrl: './admin-dashboard-tab5.component.html',
  styleUrls: ['./admin-dashboard-tab5.component.scss']
})
export class AdminDashboardTab5Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
